export default {
  enablePickupTime: "Customer Arrival Time",
  enablePickupTimeInputHeader: "Customer Arrival Time",
  enablePickupTimeText: "Allow customer to set arrival time on checkout.",
};